module.exports = __webpack_public_path__ + "img/select_arrow.d87afed1.svg";